import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { VenueEventListComponent } from "./venue-event-list/venue-event-list.component";
import { VenueEventListResolver } from "./resolvers/venue-event-list.resolver";

const routes: Routes = [
    {
      path: '',
      component: VenueEventListComponent,
      resolve: {
        eventsDetailByVenue: VenueEventListResolver
      }
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class VenueRoutingModule {
  }